import { FunctionComponent, useEffect, useState } from 'react';
import lineApi from '../../api/line';
import { LinePackets } from '../../types/line';
import { CommentsObj } from '../../types/messages';
import Messages from '../../components/Messages/Messages';

interface LineWorkpackageNotesProps {
    task: LinePackets,
    refreshLine?: Function,
    isEditMode: Boolean
}

const LineWorkpackageNotes: FunctionComponent<LineWorkpackageNotesProps> = ({ task, isEditMode, refreshLine = () => { } }) => {
    const [allComments, setAllComments] = useState<CommentsObj[]>([]);

    useEffect(() => {
        refresh();
    }, []);

    const refresh = () => {
        lineApi.GetLineMessagesByWoBarcode(task!.wo_barcode as string).then(res => {
            setAllComments(res.data)
        });
    }
    const onDelete = (commentId: number) => {
        lineApi.DeleteLineMessage(commentId).then(res => {
            if (res) {
                refresh();
            }
            refreshLine();
        });
    }

    const onAddComment = (message: string) => {
        if (message !== "") {
            lineApi.CreateLineMessage(task!.wo_barcode as string, message).then(res => {
                if (res) {
                    refresh();
                }
                refreshLine();
            });
        }
    }

    const onEdit = (commentId: number, value?: string, save?: boolean) => {

        setAllComments(prev =>
            prev.map(comment => {
                if (comment.comment_id !== commentId) return comment;

                // Start editing
                if (value === undefined && save === undefined) {
                    return { ...comment, isEditing: true, editText: comment.text };
                }
                // Update edit text
                if (value !== undefined && save === undefined) {
                    return { ...comment, editText: value };
                }
                // Save edit
                if (save) {
                    // Just close the edit mode, don't update text here
                    lineApi.EditLineMessage(commentId, comment.editText ?? comment.text).then(res => {
                        if (res.status) refresh();
                    });
                    return { ...comment, isEditing: false, editText: undefined };
                }
                // Cancel edit
                return { ...comment, isEditing: false, editText: undefined };
            })
        );
    };

    return (
        <Messages
            isEditMode={isEditMode}
            allComments={allComments}
            onAddComment={(message: string) => onAddComment(message)}
            onDelete={(commentId: number) => onDelete(commentId)}
            onEdit={onEdit}
        />
    )
}

export default LineWorkpackageNotes;